module.exports = "/assets/footer/rewards/aig_multimedia.png?/sXOf+0";